import { render, staticRenderFns } from "./DialogRecipe.vue?vue&type=template&id=a6b396c0"
import script from "./DialogRecipe.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogRecipe.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports